
import { IAnalyticsServiceConfiguration } from '..'
import { IAnalyticsTagManager } from '../../../domain/analytics/analytics-configuration'
import { ComScore } from './comscore'
import { GTM } from './gtm'
import { Permutive } from './permutive'

export interface ITagManager {
    init(tags: IAnalyticsTagManager, conf?: object): any
    initializePermutive(tags: IAnalyticsTagManager,config?: IAnalyticsServiceConfiguration): void
}

export class TagManager implements ITagManager {
    /**
     * Initialize Google Tag Manager
     */
    private permutive: Permutive
    public init(tags: IAnalyticsTagManager): void {
        if (tags.gtm && tags.gtm.length > 0) {
            const gtm = new GTM()
            tags.gtm.forEach((account: string) => {
                gtm.init(account)
            })
        }

        if (tags.comScore) {
            const comscore = new ComScore()
            comscore.init(tags.comScore)
        }

        if (tags.gtm_params && tags.gtm_params.html && tags.gtm_params.html.container_id) {
            const gtm = new GTM('gtm_data_layer')
            const gtmHtml = tags.gtm_params.html
            gtm.init(gtmHtml.container_id, gtmHtml.auth, gtmHtml.env)
        }
        this.initializePermutive(tags)
    }
    public initializePermutive(tags: IAnalyticsTagManager, config?: IAnalyticsServiceConfiguration): void {
        /**
         * Initialize permutive so we can load it before ads
         */
        if (typeof this.permutive === 'undefined' && tags.permutive && tags.permutive.organization_id) {
            this.permutive = new Permutive()
            const permutiveKeys = tags.permutive
            this.permutive.init(permutiveKeys.organization_id, permutiveKeys.workspace_id,
                permutiveKeys.workspace_api_key)
            this.permutive.sendPageViewEvent(config)
        }
    }
}
